module.exports = __webpack_public_path__ + "img/1522708515.5e90f7b8.jpg";